// @ts-nocheck
import React, { Suspense, useContext } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
// import { useHistory } from 'react-router';
import Mfa from 'auth/Mfa';
import Login from 'auth/Login';
import ErrorsForFlight from './components/errors/errorsForFlight';
import UploadFile from './components/Upload/UploadFile';
import UploadedFilesList from './components/Upload/UploadedFilesList';
import UsersManagement from './components/Users/UsersManagement/usersManagement';
import AdministratorManagement from './components/Users/AirlineAdministratorManagement/AdministratorManagement';
import AdministratorDefinition from './components/Users/AirlineAdministratorManagement/AdministratorDefinition';
import ActivityLogForUser from './components/Users/ActivityLogForUser';
import ActivityLogForAdmin from './components/Users/ActivityLogForAdmin';
import FlightList from './components/Flights/FlightList';
import Constants from './components/constants/constants';
import DocTypes from './components/DocTypes/docTypes';
import PersonList from './components/Persons/PersonList';
import ErrorsForPerson from './components/Persons/ErrorsForPerson';
import HomePage from './components/homePage';
import ExpiredSession from './components/expiredSession';
import ErroneousPassengersCrew from './components/Persons/ErroneousPassengersCrew';
import CertificatesManagement from './components/CertificatesManagement/CertificatesManagement';
import ProtectedRoute from './auth/ProtectedRoute';
import RefreshUser from './components/Modals/RefreshUser';
import Header from 'components/header';
import RouteCanActivate from 'auth/RouteCanActivate';
import AuthContext from 'store/AuthContext';
import AppSpinner from 'components/common/AppSpinner';
//import ModalContext from 'store/ModalContext';
function App(props) {  
  //const { openModal, modalDispatch } = useContext(ModalContext);
  const {userInfo} = useContext(AuthContext);
  return (
    <div className="App">
      <Header />
      <Suspense fallback={
        <AppSpinner style={{height: '100%'}}/>
      }>
        <Switch>
          <Route path='/' exact>
            <Redirect to={userInfo.isLoggedin ? (userInfo.isOwner ? "/AdministratorManagement" : "/HomePage") : "/login"} />
          </Route>          
          <Route exact path='/Mfa' component={Mfa} />
          <Route exact path='/login' component={Login} />
         <RouteCanActivate exact path='/ExpiredSession' component={ExpiredSession} canActivate={()=>!userInfo.isLoggedin} />       
          <ProtectedRoute exact path='/FlightList' component={FlightList} />
          <ProtectedRoute exact path='/ErroneousPassengersCrew/:flightId/:personType' component={ErroneousPassengersCrew}/>
          <ProtectedRoute exact path='/HomePage' component={HomePage} />
          <ProtectedRoute exact path='/Constants' component={Constants} />
          <ProtectedRoute exact path='/DocTypes' component={DocTypes} />
          <ProtectedRoute exact path='/UploadFile' component={UploadFile} />
          <ProtectedRoute exact path='/RefreshUser' component={RefreshUser} />
          <ProtectedRoute exact path='/UploadedFilesList' component={UploadedFilesList} />
          <ProtectedRoute exact path='/ActivityLogForUser/:UserName' component={ActivityLogForUser} />
          <ProtectedRoute exact path='/ActivityLogForAdmin/:UserName' component={ActivityLogForAdmin} />
          <ProtectedRoute exact path='/AdministratorDefinition' component={AdministratorDefinition} />
          <ProtectedRoute exact path='/ErrorsForPerson/:personId/:personType' component={ErrorsForPerson} />
          <ProtectedRoute exact path='/personList/:flightId/:personType' component={PersonList} />
          <ProtectedRoute exact path='/UsersManagement' component={UsersManagement} />
          <ProtectedRoute exact path='/AdministratorManagement' component={AdministratorManagement} />
          <ProtectedRoute exact path='/CertificatesManagement' component={CertificatesManagement} />
          <ProtectedRoute exact path='/ErrorsForFlight/:flightId' component={ErrorsForFlight} />
          <Route path="*" component={() => <div className="alert alert-danger" style={{ textAlign: "center" }}>404 NOT FOUND</div>} />   
        </Switch>
      </Suspense>
    </div>
  )
}
export default withRouter(App);